import { render, staticRenderFns } from "./msisdn-overview.vue?vue&type=template&id=e80a9bec&"
import script from "./msisdn-overview.vue?vue&type=script&lang=js&"
export * from "./msisdn-overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports